import { FINANCE_ROUTES, LAYOUT_NAMES } from '@/constants';

export const financeRoutes = [
  {
    path: FINANCE_ROUTES.PAYMENT_METHODS.PATH,
    name: FINANCE_ROUTES.PAYMENT_METHODS.NAME,
    component: () => import(
      '@/views/page-payment-method/page-payment-methods/page-payment-methods.vue'
    ),
    meta: { layout: LAYOUT_NAMES.MAIN },
    children: [
      {
        path: FINANCE_ROUTES.EDIT_MODE_PAYMENT_METHOD.PATH,
        name: FINANCE_ROUTES.EDIT_MODE_PAYMENT_METHOD.NAME,
        component: () => import(
          '@/views/page-payment-method/page-edit-payment-method/page-edit-payment-method.vue'
        ),
        props: true,
        meta: { layout: LAYOUT_NAMES.MAIN },
      },
    ],
  },
  {
    path: FINANCE_ROUTES.PAYMENT_METHOD_TYPES.PATH,
    name: FINANCE_ROUTES.PAYMENT_METHOD_TYPES.NAME,
    component: () => import(
      /* webpackChunkName: "page-payment-methods-types" */
      '@/views/page-payment-method/page-payment-methods-types/page-payment-methods-types.vue'
    ),
    meta: { layout: LAYOUT_NAMES.MAIN },
  },
  {
    path: FINANCE_ROUTES.NEW_PAYMENT_METHOD.PATH,
    name: FINANCE_ROUTES.NEW_PAYMENT_METHOD.NAME,
    component: () => import(
      /* webpackChunkName: "page-new-payment-method" */
      '@/views/page-payment-method/new-payment-method/page-new-payment-method.vue'
    ),
    props: true,
    meta: { layout: LAYOUT_NAMES.MAIN },
  },
  {
    path: FINANCE_ROUTES.DEPOSIT.PATH,
    name: FINANCE_ROUTES.DEPOSIT.NAME,
    component: () => import(
      /* webpackChunkName: "page-deposit" */
      '@/views/page-deposit/page-deposit.vue'
    ),
  },
  {
    path: FINANCE_ROUTES.DEPOSIT_VERIFICATION.PATH,
    name: FINANCE_ROUTES.DEPOSIT_VERIFICATION.NAME,
    component: () => import(
      /* webpackChunkName: "page-deposit-verification" */
      '@/views/page-deposit/page-deposit-verification/page-deposit-verification.vue'
    ),
  },
  {
    path: FINANCE_ROUTES.DEPOSIT_SUCCESS.PATH,
    name: FINANCE_ROUTES.DEPOSIT_SUCCESS.NAME,
    component: () => import(
      /* webpackChunkName: "page-deposit-success" */
      '@/views/page-deposit/page-deposit-success/page-deposit-success.vue'
    ),
  },
  {
    path: FINANCE_ROUTES.DEPOSIT_FAIL.PATH,
    name: FINANCE_ROUTES.DEPOSIT_FAIL.NAME,
    component: () => import(
      /* webpackChunkName: "page-deposit-fail" */
      '@/views/page-deposit/page-deposit-fail/page-deposit-fail.vue'
    ),
  },
];
